import React from 'react';
import { PhoneCall } from 'lucide-react'; 
import { FaWhatsapp } from 'react-icons/fa'; 

interface ContactBannerProps {}

const ContactBanner: React.FC<ContactBannerProps> = () => {
  const backgroundImage =
    "url('https://img.freepik.com/premium-vector/dark-blue-banner-backdrop-background_28629-2867.jpg')";
  const supportIllustration =
    'https://cdn.pixabay.com/photo/2024/02/28/15/47/ai-generated-8602325_1280.png';

  const whatsappNumber = "917782918158"; 
  const message = "Hello, I visited your website and I am interested in exploring your courses.";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <section className="px-4 sm:px-6 lg:px-8 py-10 md:py-16" aria-label="Contact and Support Banner">
      <div
        className="relative text-white py-12 px-6 md:px-16 flex flex-col md:flex-row items-center justify-between gap-10 md:gap-12 rounded-3xl shadow-2xl bg-cover bg-center overflow-hidden"
        style={{ backgroundImage: backgroundImage }}
      >
        <div className="absolute inset-0 bg-blue-900/40 opacity-50"></div>

        <div className="relative z-10 max-w-xl space-y-6 text-center md:text-left order-2 md:order-1">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold leading-tight font-aligran">
            Get expert guidance —{' '}
            <span className="text-orange-400 block sm:inline">call or WhatsApp us today!</span>
          </h2>
          
          <p className="text-base sm:text-lg font-medium text-gray-100 max-w-md mx-auto md:mx-0">
            A roadmap for readying key roles in your organization for business in
            the digital age.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-4 pt-2">
            <a
              href="tel:+917782918158"
              title="Call Project Infotech"
              className="w-full sm:w-auto flex items-center justify-center gap-3 bg-white text-blue-900 font-bold px-6 py-3 rounded-full shadow-lg hover:bg-orange-500 hover:text-white transition-all duration-300 active:scale-95"
            >
              <PhoneCall className="w-5 h-5" aria-hidden="true" /> Contact Us
            </a>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              title="WhatsApp Project Infotech"
              className="w-full sm:w-auto flex items-center justify-center gap-3 bg-green-500 text-white font-bold px-6 py-3 rounded-full shadow-lg hover:bg-green-600 transition-all duration-300 active:scale-95"
            >
              <FaWhatsapp className="w-5 h-5" aria-hidden="true" /> WhatsApp
            </a>
          </div>
        </div>

        <div className="relative z-10 flex justify-center md:justify-end w-full md:w-1/2 order-1 md:order-2">
          <img
            src={supportIllustration}
            alt="Expert IT Career Counselor"
            loading="lazy"
            className="w-48 sm:w-64 md:w-96 drop-shadow-2xl animate-pulse-slow"
          />
        </div>
      </div>
    </section>
  );
};

export default ContactBanner;